import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { inboxMessages } from '../../data/sampleData';
import { ChevronRightIcon } from 'lucide-react';
type MessageCategory = 'All' | 'Unread' | 'Mentions' | 'Deadlines' | 'Team Activity' | 'System';
export const InboxPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<MessageCategory>('All');
  const [selectedMessage, setSelectedMessage] = useState(inboxMessages[0]);
  const filteredMessages = selectedCategory === 'All' ? inboxMessages : selectedCategory === 'Unread' ? inboxMessages.filter(msg => !msg.isRead) : inboxMessages.filter(msg => msg.category === selectedCategory);
  const unreadCount = inboxMessages.filter(msg => !msg.isRead).length;
  const mentionsCount = inboxMessages.filter(msg => msg.category === 'Mentions').length;
  return <div className="flex h-[calc(100vh-12rem)] bg-white border border-gray-6 rounded-lg overflow-hidden" data-id="element-311">
      <div className="w-72 border-r border-gray-6 flex flex-col" data-id="element-312">
        <div className="p-4 border-b border-gray-6" data-id="element-313">
          <nav className="space-y-1" data-id="element-314">
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'All' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('All')} data-id="element-315">
              <span data-id="element-316">All</span>
              <span className="bg-gray-5 text-gray-11 text-xs rounded-full px-2 py-0.5" data-id="element-317">
                {inboxMessages.length}
              </span>
            </button>
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'Unread' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('Unread')} data-id="element-318">
              <span data-id="element-319">Unread</span>
              <span className="bg-indigo-5 text-indigo-11 text-xs rounded-full px-2 py-0.5" data-id="element-320">
                {unreadCount}
              </span>
            </button>
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'Mentions' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('Mentions')} data-id="element-321">
              <span data-id="element-322">Mentions</span>
              <span className="bg-gray-5 text-gray-11 text-xs rounded-full px-2 py-0.5" data-id="element-323">
                {mentionsCount}
              </span>
            </button>
            <div className="py-2" data-id="element-324">
              <div className="h-px bg-gray-6 my-2" data-id="element-325"></div>
            </div>
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'Deadlines' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('Deadlines')} data-id="element-326">
              <span data-id="element-327">Deadlines</span>
            </button>
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'Team Activity' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('Team Activity')} data-id="element-328">
              <span data-id="element-329">Team Activity</span>
            </button>
            <button className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'System' ? 'bg-indigo-3 text-indigo-11' : 'text-gray-11 hover:bg-gray-3'}`} onClick={() => setSelectedCategory('System')} data-id="element-330">
              <span data-id="element-331">System</span>
            </button>
          </nav>
        </div>
        <div className="flex-1 overflow-y-auto" data-id="element-332">
          {filteredMessages.map(message => <button key={message.id} className={`w-full text-left px-4 py-4 border-b border-gray-6 hover:bg-gray-3 transition-colors ${selectedMessage.id === message.id ? 'bg-indigo-3' : ''}`} onClick={() => setSelectedMessage(message)} data-id="element-333">
              <div className="flex items-start" data-id="element-334">
                <div className={`h-2 w-2 rounded-full mt-1.5 mr-2 ${!message.isRead ? 'bg-indigo-9' : 'bg-transparent'}`} data-id="element-335"></div>
                <div data-id="element-336">
                  <h3 className={`text-sm ${!message.isRead ? 'font-semibold text-gray-12' : 'font-medium text-gray-11'}`} data-id="element-337">
                    {message.title}
                  </h3>
                  <p className="text-xs text-gray-10 mt-1" data-id="element-338">
                    {message.sender} • {message.time}
                  </p>
                </div>
              </div>
            </button>)}
        </div>
      </div>
      <div className="flex-1 p-6 overflow-y-auto" data-id="element-339">
        {selectedMessage && <>
            <h2 className="text-xl font-semibold text-gray-12 mb-2" data-id="element-340">
              {selectedMessage.title}
            </h2>
            <div className="flex items-center text-sm text-gray-10 mb-6" data-id="element-341">
              <span data-id="element-342">From: {selectedMessage.sender}</span>
              <span className="mx-2" data-id="element-343">•</span>
              <span data-id="element-344">{selectedMessage.time}</span>
            </div>
            <div className="prose text-gray-11 mb-8" data-id="element-345">
              <p className="text-base" data-id="element-346">
                {selectedMessage.title === 'Deadline Reminder' ? <>
                    Pursuit "Downtown Office" deadline is in 3 days.
                    <br data-id="element-347" />
                    <br data-id="element-348" />
                    Please ensure all required documents are prepared and
                    reviewed before submission.
                    <br data-id="element-349" />
                    <br data-id="element-350" />
                    Required documents:
                    <br data-id="element-351" />
                    - Technical Proposal
                    <br data-id="element-352" />
                    - Fee Schedule
                    <br data-id="element-353" />
                    - Team Resumes
                    <br data-id="element-354" />- Project Approach
                  </> : selectedMessage.preview}
              </p>
            </div>
            {selectedMessage.title === 'Deadline Reminder' && <Button data-id="element-355">View Pursuit</Button>}
          </>}
      </div>
    </div>;
};